<template>
  <div class="Context" v-title data-title="“北京日”签到">
    <Head></Head>
    <div class="Border">
      <el-result icon="success" style="padding:10px 0px;"></el-result>
      <p>签到成功</p>
    </div>
    <div class="Border2">
      <span>{{Data.data}}代表您好，您的座位位于：</span>
      <div>{{Data.message}}</div>
      <p>请截图保存或牢记您的座位号！</p>
    </div>
    <!-- <p style="text-align: left;width:90%;margin:20px 0px;font-size:15px;">
      贵公司其他参会人员，请到第14排以后区域入座。
    </p> -->
    <div class="Pic">
      <div style="margin:20px 0px;">
        会场布局示意图
      </div>
      <div>
        <el-image :src="require('@/assets/success.jpg')" :preview-src-list="srcList"></el-image>
      </div>
    </div>
  </div>
</template>

<script>

import Head from '@/components/head.vue';
export default {
  name: "Success",
  components:{
      Head
  },
  data() {
    return {
        Data: {},
        srcList: [
          "/web/industry-analyze/img/success.d64df29d.jpg"
        ]
    }
  },
  created(){
    if(window.localStorage.getItem('SuccessData') != null){
      this.Data = JSON.parse(window.localStorage.getItem('SuccessData'));
    }else{
      this.$message({
        message: '请先签到',
        type: 'error'
      });
      this.$router.push({path: '/mobile/enlist',query:{}});
    }
  },
  methods: {}
}
</script>
<style scoped>
    .Context{
        width: 100%;
        height: 90%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 20px;
    }
    .Border{
      width: 95%;
      min-height: 144px;
      border: 1px solid rgba(250, 205, 145, 1);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
    }
    .Border>p{
      font-size: 20px;
      color: #F64B00;
      font-weight: 600;
      padding: 20px 0px;
    }
    .Border>span{
      font-size: 20px;
      margin-top: 30px;
    }
    .Border2{
      width: 95%;
      min-height: 200px;
      border: 1px solid rgba(250, 205, 145, 1);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
    }
    .Border2>span{
      display: block;
      width: 90%;
      text-align: left;
      padding: 20px 0px;
      padding-bottom: 10px;
    }
    .Border2>div{
      font-size: 28px;
      color: green;
      padding: 10px 0px;
    }
    .Border2>p{
      color: red;
      padding: 10px 0px;
      padding-bottom: 20px;
    }
    .Pic{
      width: 95%;
    }
    .Pic>div{
      background: #F64B00;
      color: white;
      font-weight: 200;
      padding:5px 0px;
    }
    .Pic>img{
      width: 100%;
    }
</style>
